import { Desktop } from "components";
import {
  selectOrganization,
  selectOrganizationUnit,
} from "modules/app/actions";
import { useAppState } from "modules/app/hook";
import { useUserState } from "modules/user/hook";
import { FunctionComponent } from "react";
import { DropdownElement, DropdownWrapper } from "./unit-selection.styles";
import Dropdown, { DropdownItem } from "./dropdown";

const OrganizationDropdown: FunctionComponent<any> = () => {
  const { selectedOrganizationData } = useAppState();
  const { data: userData } = useUserState();

  if (!userData || !selectedOrganizationData) {
    return null;
  }

  return (
    <DropdownWrapper>
      <Desktop>
        <div>Using as:</div>
      </Desktop>
      <DropdownElement>
        <Dropdown
          label={selectedOrganizationData.name}
          items={userData.organizations.map((organization) => {
            const item: DropdownItem = {
              text: organization.name,
              onClick: () => {
                // select chose org
                selectOrganization(organization.uuid);

                const newUnits = organization.organizationUnits.filter(
                  (unit) => {
                    if (userData.systemRole === "sysadmin") {
                      // accept all if sysadmin
                      return true;
                    }

                    // check users access to the unit
                    const hasAccess =
                      userData.organizationUnits.find(
                        (ou) => ou.uuid === unit.uuid,
                      ) !== undefined;
                    return hasAccess;
                  },
                );

                const firstUnit = newUnits[0];
                if (firstUnit) {
                  selectOrganizationUnit(firstUnit.uuid);
                }
              },
            };
            return item;
          })}
        />
      </DropdownElement>
    </DropdownWrapper>
  );
};

export default OrganizationDropdown;
